import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDistinctFilteredInstalledProductsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Installed_Products_Bool_Exp>;
  user_id: Types.Scalars['String']['input'];
}>;


export type GetDistinctFilteredInstalledProductsQuery = { __typename?: 'query_root', installed_products: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, location?: string | null, building_id?: any | null, floor_id?: any | null, room_id?: any | null, in_room_location?: any | null, partition_id?: string | null, photo_link?: string | null, device_status?: string | null, partner_disconnected_at?: any | null, partner_association?: string | null, building?: { __typename?: 'buildings', id: any, name: string } | null, floor?: { __typename?: 'floors', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, installed_products_aggregate: { __typename?: 'installed_products_aggregate', aggregate?: { __typename?: 'installed_products_aggregate_fields', count: number } | null } }, property?: { __typename?: 'properties', id: any, name: string, partner_association?: string | null, partner_id?: string | null } | null }>, product_categories: Array<{ __typename?: 'product_categories', name: string, label: string }>, Distinct_Properties_By_Product_By_User_Id: Array<{ __typename?: 'Distinct_Properties_By_Product_By_User_Id', product_id: any, product_name: string, property_count: any }> };


export const GetDistinctFilteredInstalledProductsDocument = gql`
    query getDistinctFilteredInstalledProducts($where: installed_products_bool_exp, $user_id: String!) {
  installed_products(
    where: $where
    distinct_on: product_id
    order_by: {product_id: desc}
  ) {
    id
    product_id
    property_id
    installation_date
    warranty_expiration_date
    warranty_status
    product_serial
    location
    building_id
    floor_id
    room_id
    in_room_location
    building {
      id
      name
    }
    floor {
      id
      name
    }
    room {
      id
      name
    }
    partition_id
    photo_link
    device_status
    partner_disconnected_at
    partner_association
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      photo_link
      installed_products_aggregate(where: $where) {
        aggregate {
          count
        }
      }
    }
    property {
      id
      name
      partner_association
      partner_id
    }
  }
  product_categories {
    name
    label
  }
  Distinct_Properties_By_Product_By_User_Id(args: {user_id: $user_id}) {
    product_id
    product_name
    property_count
  }
}
    `;

/**
 * __useGetDistinctFilteredInstalledProductsQuery__
 *
 * To run a query within a React component, call `useGetDistinctFilteredInstalledProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistinctFilteredInstalledProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistinctFilteredInstalledProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetDistinctFilteredInstalledProductsQuery(baseOptions: Apollo.QueryHookOptions<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables> & ({ variables: GetDistinctFilteredInstalledProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables>(GetDistinctFilteredInstalledProductsDocument, options);
      }
export function useGetDistinctFilteredInstalledProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables>(GetDistinctFilteredInstalledProductsDocument, options);
        }
export function useGetDistinctFilteredInstalledProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables>(GetDistinctFilteredInstalledProductsDocument, options);
        }
export type GetDistinctFilteredInstalledProductsQueryHookResult = ReturnType<typeof useGetDistinctFilteredInstalledProductsQuery>;
export type GetDistinctFilteredInstalledProductsLazyQueryHookResult = ReturnType<typeof useGetDistinctFilteredInstalledProductsLazyQuery>;
export type GetDistinctFilteredInstalledProductsSuspenseQueryHookResult = ReturnType<typeof useGetDistinctFilteredInstalledProductsSuspenseQuery>;
export type GetDistinctFilteredInstalledProductsQueryResult = Apollo.QueryResult<GetDistinctFilteredInstalledProductsQuery, GetDistinctFilteredInstalledProductsQueryVariables>;